import React from "react";
import ReactApexChart from "react-apexcharts";

const ApexLine4 = ({ series, categories }) => {
  const options = {
    chart: {
      height: 350,
      type: "line",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 5,
      curve: "straight",
    },
    xaxis: {
      categories: categories,
      title: {
        text: "الدفعات",
      },
    },
    yaxis: {
        categories: categories,
        title: {
          text: "الدفعات",
        },
    },
    legend: {
      position: "bottom",
    },
    markers: {
      size: 10,
      strokeWidth: 4,
      color:"#0909",
    },
    colors: ["#363062", "#1EA7C5", "#FF9432", "#00E396", "#775DD0", "#FF4560"],
  };

  return (
    <div id="chart" className="bar-chart">
      <ReactApexChart options={options} series={series} type="line" height={350} />
    </div>
  );
};

export default ApexLine4;
